/**
 * 更多測試頁 — 繁體中文（嵌套結構，對應 t('tests.…')，m / pc 共用）
 */
export default {
	meta: {
		breadcrumb: "更多測試",
		title: "更多測試 - 先知命局",
		keywords: "線上測試,更多測試,命理測試,心理測試",
		description: "探索更多線上測試，涵蓋心理、感情、事業、學術命理等分類，找到適合你的測試。",
	},
	pageHeader: {
		breadcrumbHome: "首頁",
		breadcrumbCurrent: "更多測試",
		searchPlaceholder: "請輸入測試關鍵詞搜索",
		searchButton: "搜尋",
		clearSearch: "清除搜索",
	},
	rankSidebar: {
		title: "測算排行榜",
		defaultDesc: "讓你掌握未來、趨吉避凶！",
		testCount: "{count}人測過",
		promoTitle: "不知道測什麼？",
		promoBubble: "試試和 MasterS 對話吧～",
		promoButton: "進入對話",
	},
	productPanel: {
		tabsAriaLabel: "測試分類",
		categoryAll: "全部",
		categoryFunTest: "趣味測試",
		funTestTitle: "免費趣味測試",
		testCount: "{count}人測過",
		testNow: "立即測試",
		empty: "暫無相關測試",
		paginationAriaLabel: "測試列表分頁",
		prevPage: "上一頁",
		nextPage: "下一頁",
		jumpTo: "前往",
		pageUnit: "頁",
		tabIcons: {
			all: "全",
			xinli: "心",
			bazixiangpi: "八",
			danrenyinyuan: "緣",
			shiye: "業",
			liunian: "運",
			tarot: "塔",
			zonghe: "綜",
			english: "En",
			other: "其",
			fun_test: "趣",
		},
		categoryOther: "其他",
	},
};
